import { Controller } from '@hotwired/stimulus'

/**
 * Remove elements from the DOM on an action: button clicks or when a CSS animation ends, for ex:
 *
 *     <div
 *         class="animate__animated animate__fadeOut"  <-- animate.css animation
 *         data-controller="remove-elements"
 *         data-action="animationend->remove-elements#remove">
 *         I will hide after CSS animation ends
 *     </div>
 *
 */
export default class extends Controller {
    remove() {
        this.element.remove()
    }
}
